import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportSaldoBancarioListaUseCase } from "../../../presentation/useCases/read/get_report_saldo_bancario_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportSaldoBancarioListaUseCase
 */

export type GetReportSaldoBancarioListaParams = {
  requiredMimeType: ReportMimeType | null,
  idBancoPagamento?: number;
  dataDe?: Date | null;
  dataAte?: Date | null;
  tipoMovimento?: number[] | null;
  idUsuario?: number | null;

};

export class GetReportSaldoBancarioListaUseCase implements IGetReportSaldoBancarioListaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(params: GetReportSaldoBancarioListaParams): Promise<ReportData> {

    const tipoMovimentoStr = params.tipoMovimento ? params.tipoMovimento.filter(x => x !== 0).join(',') : null;

    const response = await this.repository.getReportSaldoBancarioLista(
      params.requiredMimeType ?? "text/html",
      params.idBancoPagamento,
      params.dataDe ?? null,
      params.dataAte ?? null,
      tipoMovimentoStr,
      params.idUsuario ?? null
    );

    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = params.idBancoPagamento === undefined
        ? `saldo_bancario_lista_${new Date().toISOString()}.${response.filenameExtension}`
        : `saldo_bancario_${new Date().toISOString()}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;


  }
}